import LuxonAdapter from '@date-io/luxon';

export const luxon = new LuxonAdapter({ locale: 'en-US' });
